import { Pipe, PipeTransform } from '@angular/core';
import { SYNDICATION_CHANNELS_CONFIG } from '../domain/channel-config.model';
import { SyndicationChannel } from '../domain/syndication-channels.model';

@Pipe({
  name: 'channelName',
  standalone: true,
})
export class ChannelNamePipe implements PipeTransform {
  transform(value: SyndicationChannel): string {
    const item = SYNDICATION_CHANNELS_CONFIG[value];

    return item.name;
  }
}
